import store from "..";
import SVG, {  unselectize } from '../../utils/svg';
import {
    REMOVE_RULER,
    REMOVE_RULERS,
    SET_CURRENT_TAB,
    SET_NEW_ZONE,
    SET_SELECTED_ZONE,
    SET_ZONES,
    SET_ZONES_VISIBILITY,
    SET_ZONE_DRAW,
    SET_ZOOM_TO_ELEMENT_ID,
    UPDATE_RULER,
    UPDATE_ZONE,
} from "../actions/Store";

const initialState = {
    selectedParentStore: null,
    selectedSubStore: null,
    selectedPlanogram: null,
    stores: [],
    shelves: [],
    products: [],
    isSceneUpdated: false,
    unsavedModifications: false,
    recenterMap: false,
    previewVisible: false,
    selectedProduct: null,
    isEdit: false,
    isStoreSceneUpdated: false,
    isFloorEdit: false,
    storeData: null,
    isInfoWindowVisible: false,
    selectedStoreElement: null,
    isDragEnabled: true,
    snapToRuler: true,
    moveElementsWithRuler: false,
    //history: [],
    //historyStep: 0,
    showElements: null,
    isWallDrawEnabled: false,
    floorMapLayerProperties: null,
    storeUpdated: false,
    zones: [],
    selectedZone: null,
    zonesVisibility: {},
    zonesHasChanges: {},
    currentTab: '',
    newZone: null,
    isZoneDrawEnabled: false,
    zoomToElementId: null,
    sideBarIsOpened: true,
};

export default function StoreReducer(state = initialState, action) {
    switch (action.type) {
        case "SET_PARENT_STORE": {
            return {
                ...state,
                selectedParentStore: action.selectedStore
            };
        }

        case "SET_SUB_STORE": {
            return {
                ...state,
                selectedSubStore: action.selectedStore
            };
        }

        case "SET_STORES": {
            return {
                ...state,
                stores: action.stores
            }
        }

        case "SET_SHELVES": {
            return {
                ...state,
                shelves: action.shelves
            }
        }

        case "SET_PLANOGRAM": {
            return {
                ...state,
                selectedPlanogram: action.selectedPlanogram
            }
        }

        case "SET_PRODUCTS": {
            return {
                ...state,
                products: action.products
            }
        }

        case "SET_IS_SCENE_UPDATED": {
            return {
                ...state,
                isSceneUpdated: action.isSceneUpdated
            }
        }

        case "SET_UNSAVED_MODIFICATIONS": {
            return {
                ...state,
                unsavedModifications: action.unsavedModifications
            }
        }

        case "SET_RECENTER_MAP": {
            return {
                ...state,
                recenterMap: action.recenterMap
            }
        }

        case "SET_PREVIEW_VISIBLE": {
            return {
                ...state,
                previewVisible: action.previewVisible
            }
        }

        case "SET_PRODUCT": {
            return {
                ...state,
                selectedProduct: action.selectedProduct
            }
        }

        case "SET_IS_EDIT": {
            return {
                ...state,
                isEdit: action.isEdit
            }
        }

        case "SET_IS_STORE_SCENE_UPDATED": {
            return {
                ...state,
                isStoreSceneUpdated: action.isStoreSceneUpdated
            }
        }

        case "SET_IS_FLOOR_EDIT": {
            return {
                ...state,
                isFloorEdit: action.isFloorEdit
            }
        }

        case "SET_STORE_DATA": {
            return {
                ...state,
                storeData: action.storeData
            }
        }

        case "SET_FLOOR_PLAN_ELEMENTS": {
            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    floor_plan_elements: action.elements
                }
            };
        }

        case "ADD_FLOOR_PLAN_ELEMENT": {
            const { element } = action;

            const list3D = state.storeData?.floor_plan_elements_3D;
            const updatedElements3D = [...list3D];

            const indexToUpdate = list3D?.findIndex(
                el => el.project_id === element.project_id
            );
    
            const newPosition = {
                positionX: element.positionX,
                positionY: element.positionY,
                positionZ: element.positionZ,
                angle: element.angle,
                id: element.id,
                generated_id: element.generated_id
            };
    
            // if the projects model exits then push a new position otherwise load the model and push as new item
            if(indexToUpdate !== -1) {
                updatedElements3D[indexToUpdate] = {
                    ...updatedElements3D[indexToUpdate],
                    positions: [
                        ...updatedElements3D[indexToUpdate].positions,
                        newPosition
                    ]
                }

                return {
                    ...state,
                    storeData: {
                        ...state.storeData,
                        floor_plan_elements: [
                            ...state.storeData.floor_plan_elements,
                            action.element
                        ],
                        floor_plan_elements_3D: updatedElements3D
                    }
                };
            } else {
                let newElement = element;
                newElement.positions = [newPosition];
                
                return {
                    ...state,
                    storeData: {
                        ...state.storeData,
                        floor_plan_elements: [
                            ...state.storeData.floor_plan_elements,
                            element
                        ],
                        floor_plan_elements_3D: [
                            ...state.storeData.floor_plan_elements_3D,
                            newElement
                        ]
                    }
                };
            }
        }

        case "UPDATE_FLOOR_PLAN_ELEMENT": {
            const { element } = action;

            const updatedElements = state.storeData?.floor_plan_elements?.map(
                el => (
                    (element.generated_id && element.generated_id === el.generated_id)
                    || (element.id && element.id === el.id)
                ) ? element : el
            );

            const list3D = state.storeData?.floor_plan_elements_3D;

            if(!list3D) return state;

            const updatedElements3D = [...list3D];

            if(list3D) {
                list3D.forEach((item, index) => {
                    if(element.project_id != item.project_id) {
                        return;
                    }

                    const index3D = item.positions.findIndex(
                        el => (element.generated_id && element.generated_id === el.generated_id)
                        || (element.id && element.id === el.id)
                    );

                    if (index3D < 0) return state;
                    updatedElements3D[index].positions[index3D] = {
                        positionX: element.positionX,
                        positionY: element.positionY,
                        positionZ: element.positionZ,
                        angle: element.angle,
                        id: element.id,
                        generated_id: element.generated_id
                    }
                })
            }

            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    floor_plan_elements: updatedElements,
                    floor_plan_elements_3D: updatedElements3D
                }
            };
        }

        case "REMOVE_FLOOR_PLAN_ELEMENT": {
            const { element } = action;

            const list = state.storeData?.floor_plan_elements;
            if (!list) return state;

            const updatedElements = [...list];
            const index = updatedElements.findIndex(
                el => (element.generated_id && element.generated_id === el.generated_id)
                || (element.id && element.id === el.id)
            );
            if (index < 0) return state;
            if ( element.is_wall) {
                const id = element.id || element.generated_id;
                unselectize(SVG.adopt(document.getElementById(`Wall_${id}`)));
            }
            updatedElements.splice(index, 1);

            const list3D = state.storeData?.floor_plan_elements_3D;
            if (!list3D) return state;

            const updatedElements3D = [...list3D];
            list3D.forEach((item, index) => {
                if(element.project_id != item.project_id) {
                    return;
                }

                const index3D = item.positions.findIndex(
                    el => (element.generated_id && element.generated_id === el.generated_id)
                    || (element.id && element.id === el.id)
                );

                if (index3D < 0) return state;
                updatedElements3D[index].positions.splice(index3D, 1);
            })

            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    floor_plan_elements: updatedElements,
                    floor_plan_elements_3D: updatedElements3D
                }
            };
        }

        case UPDATE_RULER: {
            const { ruler } = action;
            const updatedRulers = state.storeData?.rulers?.map(
                r => (
                    (ruler.generated_id && ruler.generated_id === r.generated_id)
                    || (ruler.id && ruler.id === r.id)
                ) ? ruler : r
            );
            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    rulers: updatedRulers
                }
            };
        }

        case REMOVE_RULER: {
            const { ruler } = action;

            const updatedRulers = state.storeData?.rulers?.filter(
                r => !(
                    (ruler.generated_id && ruler.generated_id === r.generated_id)
                    || (ruler.id && ruler.id === r.id)
                )
            );
            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    rulers: updatedRulers,
                },
            };
        }

        case REMOVE_RULERS: {
            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    rulers: [],
                },
            };
        }

        case "SET_IS_INFO_WINDOW_VISIBLE": {
            return {
                ...state,
                isInfoWindowVisible: action.isInfoWindowVisible
            }
        }

        case "SET_SELECTED_STORE_ELEMENT": {
            return {
                ...state,
                selectedStoreElement: action.selectedStoreElement
            }
        }

        case "SET_IS_DRAG_ENABLED": {
            return {
                ...state,
                isDragEnabled: action.isDragEnabled
            }
        }

        case "SET_IS_GRID_ENABLED": {
            return {
                ...state,
                isGridEnabled: action.isGridEnabled
            }
        }

        case "SET_SNAP_TO_RULER": {
            return {
                ...state,
                snapToRuler: action.snapToRuler
            }
        }

        case "SET_MOVE_ELEMENTS_WITH_RULER": {
            return {
                ...state,
                moveElementsWithRuler: action.moveElementsWithRuler
            }
        }

        /*
        case "SET_HISTORY": {
            return {
                ...state,
                history: state.history.concat(action.history)
            }
        }

        case "SET_HISTORY_STEP": {
            return {
                ...state,
                historyStep: action.historyStep
            }
        }

        case "CLEAR_HISTORY": {
            return {
                history: []
            }
        }
        */

        case "RESET" : {
            return initialState;
        }

        case "SET_SHOW_ELEMENTS": {
            return {
                ...state,
                showElements: action.showElements
            }
        }
        
        case "SET_IS_WALL_DRAW_ENABLED": {
            return {
                ...state,
                isWallDrawEnabled: action.isWallDrawEnabled
            }
        }

        case "SET_FLOOR_MAP_LAYER_PROPERTIES" : {
            return {
                ...state,
                floorMapLayerProperties: action.floorMapLayerProperties
            }
        }

        case "SET_STORE_UPDATED" : {
            return {
                ...state,
                storeUpdated: action.storeUpdated
            }
        }

        case SET_ZONES: {

            const visibility = {};
            if (action.zones) action.zones.forEach(z => visibility[z.id] = true);

            return {
                ...state,
                zones: action.zones,
                zonesVisibility: { ...visibility, ...state.zonesVisibility }
            };

        }

        case SET_SELECTED_ZONE: {

            return { ...state, selectedZone: action.zone };

        }

        case UPDATE_ZONE: {

            const updated = action.zone;

            const zones = state.zones.map(zone => {
                return zone.id === updated.id ? { ...zone, ...updated } : zone;
            });

            const hasChanges = {};
            hasChanges[updated.id] = true;

            return {
                ...state,
                zones: zones,
                zonesHasChanges: {
                    ...state.zonesHasChanges,
                    ...hasChanges
                }
            };

        }

        case SET_ZONES_VISIBILITY: {

            return { ...state, zonesVisibility: action.zonesVisibility };

        }

        case SET_CURRENT_TAB: {

            return { ...state, currentTab: action.currentTab };

        }

        case SET_NEW_ZONE: {

            return { ...state, newZone: action.newZone };

        }

        case SET_ZONE_DRAW: {

            return { ...state, isZoneDrawEnabled: action.isZoneDraw };

        }

        case SET_ZOOM_TO_ELEMENT_ID: {

            return { ...state, zoomToElementId: action.elementId };

        }

        case "SET_SIDEBAR_IS_OPENED": {
            return {
                ...state,
                sideBarIsOpened: action.sideBarIsOpened,
            };
        }

        default: return state;
    }
}
